var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _ellipse2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse3, _ellipse4, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _rect2, _path19, _path20, _rect3, _path21, _path22, _rect4, _path23, _path24, _rect5, _path25, _path26, _rect6, _path27, _path28, _rect7, _path29, _path30, _rect8, _path31, _path32, _rect9, _path33, _ellipse5, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 185,
    viewBox: "0 0 187 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.6687,
    cy: 157.519,
    rx: 57.3134,
    ry: 13.6714,
    fill: "url(#paint0_radial_14011_169615)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8339 146.203C80.8343 152.243 81.5523 157.138 78.543 157.138C75.4264 157.139 72.3149 150.466 72.3143 144.428C72.3142 138.387 77.2779 135.268 78.5428 135.268C79.8078 135.268 80.8342 140.166 80.8339 146.203Z",
    fill: "#FF9B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.882 146.203C105.882 152.243 105.165 157.139 108.175 157.139C111.292 157.139 114.404 150.466 114.404 144.428C114.404 138.387 109.441 135.269 108.175 135.269C106.91 135.269 105.882 140.166 105.882 146.203Z",
    fill: "#FF9B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.671 80.7587C151.556 76.668 159.082 72.1775 161.124 77.1046C163.234 82.204 154.42 91.8196 144.532 95.9081C134.648 99.9996 126.18 93.9903 125.322 91.9195C124.465 89.8449 131.786 84.849 141.671 80.7587Z",
    fill: "#FF9B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2672 80.2252C35.3815 76.1347 27.8554 71.6443 25.8143 76.5703C23.7036 81.6697 32.5185 91.2851 42.4054 95.3758C52.2898 99.4672 60.7565 93.4564 61.6161 91.3835C62.4731 89.3112 55.1521 84.3143 45.2672 80.2252Z",
    fill: "#FF9B2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.731 116.567C141.731 141.119 121.825 146.203 97.2698 146.203H89.8627C65.3072 146.203 45.403 141.119 45.403 116.567V64.7058C45.403 40.1536 65.3072 20.2488 89.8627 20.2488H97.2698C121.825 20.2488 141.731 40.1536 141.731 64.7058V116.567Z",
    fill: "#FF9B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.412 81.8684C137.412 83.5968 137.35 107.478 137.222 109.052C135.321 132.694 119.306 139.39 93.3594 139.39C67.2539 139.39 51.2049 132.615 49.4623 108.625C49.3572 107.179 49.3035 83.4416 49.3035 81.8684C49.3035 54.1919 65.6805 31.7556 93.3594 31.7556C121.038 31.7556 137.412 54.1919 137.412 81.8684Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 93.5659,
    cy: 81.0418,
    rx: 47.4669,
    ry: 31.6629,
    fill: "url(#paint1_radial_14011_169615)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.403 57.6398C126.403 66.875 118.913 74.3596 109.68 74.3596C100.444 74.3596 92.9577 66.875 92.9577 57.6398C92.9577 48.4057 100.444 40.92 109.68 40.92C118.913 40.92 126.403 48.4057 126.403 57.6398Z",
    fill: "#FF9B2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.207 57.6396C123.207 65.1098 117.151 71.1656 109.68 71.1656C102.209 71.1656 96.1526 65.1098 96.1526 57.6396C96.1526 50.1693 102.209 44.1135 109.68 44.1135C117.151 44.1135 123.207 50.1693 123.207 57.6396Z",
    fill: "url(#paint2_radial_14011_169615)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.955 57.64C116.955 61.6584 113.697 64.9159 109.678 64.9159C105.66 64.9159 102.402 61.6584 102.402 57.64C102.402 53.6216 105.66 50.364 109.678 50.364C113.697 50.364 116.955 53.6216 116.955 57.64Z",
    fill: "url(#paint3_radial_14011_169615)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M113.082 57.64C113.082 59.519 111.557 61.0432 109.679 61.0432C107.799 61.0432 106.275 59.519 106.275 57.64C106.275 55.7609 107.799 54.2367 109.679 54.2367C111.557 54.2367 113.082 55.7609 113.082 57.64Z",
    fill: "#2E2A49"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1721 57.1581C94.1721 66.3933 86.6868 73.8779 77.4508 73.8779C68.2159 73.8779 60.7272 66.3933 60.7272 57.1581C60.7272 47.9229 68.2159 40.4383 77.4508 40.4383C86.6868 40.4383 94.1721 47.9229 94.1721 57.1581Z",
    fill: "#FF9B2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9772 57.1584C90.9772 64.6286 84.9208 70.6844 77.45 70.6844C69.9791 70.6844 63.9227 64.6286 63.9227 57.1584C63.9227 49.6881 69.9791 43.6323 77.45 43.6323C84.9208 43.6323 90.9772 49.6881 90.9772 57.1584Z",
    fill: "url(#paint4_radial_14011_169615)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7283 57.1574C84.7283 61.1764 81.47 64.4345 77.4507 64.4345C73.4313 64.4345 70.173 61.1764 70.173 57.1574C70.173 53.1384 73.4313 49.8804 77.4507 49.8804C81.47 49.8804 84.7283 53.1384 84.7283 57.1574Z",
    fill: "url(#paint5_radial_14011_169615)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.856 57.1578C80.856 59.038 79.3293 60.5623 77.4512 60.5623C75.5697 60.5623 74.0465 59.038 74.0465 57.1578C74.0465 55.2788 75.5697 53.7534 77.4512 53.7534C79.3293 53.7534 80.856 55.2788 80.856 57.1578Z",
    fill: "#2E2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.448,
    cy: 53.5637,
    rx: 4.05083,
    ry: 3.11204,
    fill: "url(#paint6_linear_14011_169615)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.678,
    cy: 53.5637,
    rx: 4.05083,
    ry: 3.11204,
    fill: "url(#paint7_linear_14011_169615)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4657 80.392C70.8956 80.392 53.1425 76.2453 45.2487 72.597C49.2697 76.2383 68.0978 81.8684 93.4657 81.8684C118.637 81.8684 137.735 76.1963 141.714 72.5562C133.784 76.2138 115.861 80.392 93.4657 80.392Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4657 80.1986C70.8956 80.1986 53.1425 76.0508 45.2487 72.4024C49.2697 76.0438 68.0978 81.6727 93.4657 81.6727C118.637 81.6727 137.735 76.0029 141.714 72.3616C133.784 76.0204 115.861 80.1986 93.4657 80.1986Z",
    fill: "#6D0F0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9977 80.175V82.4871C89.9977 84.5808 91.6948 86.2778 93.7876 86.2778C95.8815 86.2778 97.5786 84.5808 97.5786 82.4871V80.175H89.9977Z",
    fill: "#EDDD9A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5912 80.175V82.1253C90.5912 83.8911 92.021 85.3219 93.787 85.3219C95.5518 85.3219 96.9839 83.8911 96.9839 82.1253V80.175H90.5912Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.58095,
    height: 2.23266,
    transform: "matrix(1 0 0 -1 89.9977 82.4077)",
    fill: "#E66D28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6351 80.12C98.6363 80.1305 98.6351 80.1398 98.6363 80.148L98.7974 83.2688C98.9468 86.1177 101.375 88.3083 104.226 88.1601C107.075 88.013 109.266 85.582 109.117 82.7343L108.955 79.6135C108.954 79.6041 108.954 79.5936 108.954 79.5854L98.6351 80.12Z",
    fill: "#EDDD9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4448 80.0791V80.1013L99.5813 82.7331C99.705 85.1361 101.755 86.9825 104.158 86.8588C106.56 86.7339 108.407 84.6845 108.283 82.2826L108.146 79.6508C108.146 79.6426 108.146 79.6344 108.144 79.6274L99.4448 80.0791Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 10.3332,
    height: 3.04263,
    transform: "matrix(-0.998661 0.0517303 0.0517391 0.998661 108.953 79.5847)",
    fill: "#E66D28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.022 79.4246V79.4421L110.238 81.2733C110.435 82.9445 111.949 84.142 113.62 83.9447C115.295 83.7487 116.489 82.2326 116.293 80.5602L116.078 78.729C116.078 78.7232 116.076 78.7185 116.075 78.7126L110.022 79.4246Z",
    fill: "#EDDD9A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.496 79.3696V79.3836L110.678 80.9277C110.845 82.3375 112.12 83.3471 113.532 83.1802C114.942 83.0156 115.95 81.7376 115.783 80.3266L115.604 78.7826C115.602 78.7791 115.602 78.7732 115.6 78.7686L110.496 79.3696Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.09627,
    height: 1.79616,
    transform: "matrix(-0.993137 0.116953 0.116973 0.993135 116.077 78.7119)",
    fill: "#E66D28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.473 78.5692C117.475 78.5762 117.477 78.5832 117.477 78.5914L117.905 81.0155C118.293 83.2294 120.405 84.7082 122.62 84.3183C124.834 83.9285 126.311 81.8184 125.922 79.6044L125.495 77.1792C125.495 77.1722 125.493 77.1664 125.49 77.1582L117.473 78.5692Z",
    fill: "#EDDD9A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.101 78.459C118.104 78.4637 118.104 78.4707 118.105 78.4765L118.464 80.5213C118.794 82.3886 120.572 83.6351 122.44 83.306C124.307 82.978 125.554 81.1993 125.227 79.3308L124.865 77.2872C124.863 77.2814 124.863 77.2744 124.862 77.2686L118.101 78.459Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 8.14235,
    height: 2.39605,
    transform: "matrix(-0.984888 0.17319 0.17322 0.984883 125.492 77.1582)",
    fill: "#E66D28"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M127.984 76.6358C127.987 76.6416 127.989 76.6486 127.989 76.6556L128.548 78.8801C129.057 80.9108 131.116 82.1433 133.146 81.6321C135.179 81.1233 136.409 79.0633 135.901 77.0337L135.341 74.8104C135.341 74.8046 135.339 74.7976 135.336 74.7917L127.984 76.6358Z",
    fill: "#EDDD9A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128.561 76.4908C128.561 76.4966 128.562 76.5036 128.565 76.5083L129.035 78.3838C129.465 80.0948 131.2 81.1347 132.912 80.7052C134.627 80.2757 135.665 78.539 135.236 76.8269L134.764 74.9526C134.764 74.9479 134.761 74.9409 134.759 74.9351L128.561 76.4908Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.57975,
    height: 2.2315,
    transform: "matrix(-0.969921 0.243421 0.243461 0.969911 135.335 74.7917)",
    fill: "#E66D28"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2982 80.0969V80.1191L87.1652 82.6622C87.0461 84.9835 85.0666 86.7692 82.7438 86.6478C80.42 86.5276 78.6377 84.5482 78.7579 82.2268L78.8898 79.6837V79.6604L87.2982 80.0969Z",
    fill: "#EDDD9A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6397 80.062V80.0818L86.5289 82.2246C86.4261 84.183 84.757 85.6874 82.7985 85.5858C80.8411 85.4843 79.3342 83.8142 79.437 81.857L79.5478 79.713C79.5478 79.7072 79.5478 79.7002 79.5502 79.6943L86.6397 80.062Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 8.41782,
    height: 2.48124,
    transform: "matrix(0.998655 0.0518412 0.0518504 -0.998655 78.761 82.1365)",
    fill: "#E66D28"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7007 79.49V79.5075L77.4848 81.3387C77.2875 83.01 75.7725 84.2062 74.1022 84.0102C72.4273 83.8141 71.2333 82.298 71.4293 80.6256L71.6441 78.7944C71.6441 78.7886 71.6464 78.7839 71.6476 78.7781L77.7007 79.49Z",
    fill: "#EDDD9A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2263 79.4338V79.4478L77.0442 80.9919C76.8773 82.4017 75.6016 83.4113 74.1904 83.2444C72.7805 83.0798 71.772 81.8019 71.9389 80.3908L72.1186 78.8479C72.1198 78.8433 72.1198 78.8374 72.1222 78.8328L77.2263 79.4338Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.09627,
    height: 1.79615,
    transform: "matrix(0.993138 0.116952 0.116974 -0.993135 71.4363 80.561)",
    fill: "#E66D28"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0007 78.8237C70.9995 78.8307 70.9995 78.84 70.9972 78.847L70.5642 81.515C70.1697 83.9519 67.8738 85.6057 65.4367 85.21C63.0007 84.8144 61.3468 82.5199 61.7413 80.083L62.1755 77.4162C62.1755 77.408 62.1779 77.401 62.1802 77.3928L71.0007 78.8237Z",
    fill: "#EDDD9A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3073 78.7114C70.3073 78.7173 70.3049 78.7243 70.3049 78.7301L69.9396 80.9802C69.6058 83.0343 67.6717 84.4302 65.6151 84.0964C63.562 83.7638 62.1661 81.8276 62.4999 79.7735L62.8652 77.5233C62.8676 77.5175 62.8687 77.5116 62.8687 77.5046L70.3073 78.7114Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 8.93837,
    height: 2.63181,
    transform: "matrix(0.987107 0.160065 0.160092 -0.987102 61.7558 79.9895)",
    fill: "#E66D28"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3407 76.3369C57.3407 76.3415 57.3407 76.345 57.3384 76.3497L56.9299 77.8914C56.5564 79.2989 55.1137 80.1369 53.7049 79.7635C52.2984 79.39 51.4604 77.9463 51.8327 76.5399L52.2401 74.9994C52.2424 74.9947 52.2447 74.9889 52.2447 74.9854L57.3407 76.3369Z",
    fill: "#EDDD9A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9435 76.2297C56.9411 76.2343 56.9411 76.2378 56.9388 76.2425L56.5945 77.5426C56.2805 78.7284 55.0631 79.4345 53.8761 79.1206C52.6902 78.8054 51.9829 77.5893 52.2968 76.4012L52.6423 75.1011C52.6423 75.0987 52.6447 75.0952 52.647 75.0906L56.9435 76.2297Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 5.2722,
    height: 1.55108,
    transform: "matrix(0.966585 0.256347 0.256388 -0.966574 51.8474 76.4851)",
    fill: "#E66D28"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.537 116.887C125.537 126.331 111.322 133.986 93.7869 133.986C76.2544 133.986 62.0391 126.331 62.0391 116.887C62.0391 107.443 76.2544 99.7881 93.7869 99.7881C111.322 99.7881 125.537 107.443 125.537 116.887Z",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.5143,
    cy: 54.2371,
    rx: 40.1608,
    ry: 30.4803,
    fill: "url(#paint8_linear_14011_169615)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4494 29.4078L92.9741 25.1105C92.9741 25.1105 88.299 10.0901 79.7791 8.14976C88.6454 15.788 87.4494 29.4078 87.4494 29.4078Z",
    fill: "url(#paint9_linear_14011_169615)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M68.358 10.6522C77.2046 14.9503 79.1775 26.2664 79.1775 26.2664L82.7318 21.5784C82.7318 21.5784 75.8635 10.6454 68.6188 10.6507C68.533 10.6454 68.4486 10.6512 68.358 10.6522Z",
    fill: "url(#paint10_linear_14011_169615)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9025 19.8771C69.2144 20.5441 73.5623 27.9252 73.5623 27.9252L74.8141 23.7202C74.8141 23.7202 69.1461 19.4226 64.3454 19.4227C63.4918 19.4222 62.6652 19.5597 61.9025 19.8771Z",
    fill: "url(#paint11_linear_14011_169615)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7522 30.3804L66.7487 28.2711C66.7487 28.2711 63.8943 22.4087 60.2778 22.1473C64.3912 24.727 64.7522 30.3804 64.7522 30.3804Z",
    fill: "url(#paint12_linear_14011_169615)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9093 28.0848C60.2854 28.4359 62.2557 31.8773 62.2557 31.8773L62.8598 29.9394C62.8598 29.9394 60.2261 27.8888 57.9935 27.8883C57.6169 27.8887 57.2484 27.9463 56.9093 28.0848Z",
    fill: "url(#paint13_linear_14011_169615)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6216 30.4601C58.8359 31.3762 59.476 34.0979 59.476 34.0979L60.2735 32.9085C60.2735 32.9085 58.5168 30.4517 56.7901 30.452C56.7343 30.4519 56.6774 30.4533 56.6216 30.4601Z",
    fill: "url(#paint14_linear_14011_169615)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0884 22.2267L100.974 25.5478C100.974 25.5478 97.892 12.7262 105.281 4.16734C97.4242 7.21979 95.0884 22.2267 95.0884 22.2267Z",
    fill: "url(#paint15_linear_14011_169615)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.531 21.7264L104.992 24.6596C104.992 24.6596 105.923 17.2418 111.548 14.1824C106.771 14.2317 102.531 21.7264 102.531 21.7264Z",
    fill: "url(#paint16_linear_14011_169615)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M113.043 24.0875L114.646 26.6192C114.646 26.6192 116.139 20.9577 120.826 19.167C120.671 19.1498 120.515 19.1382 120.362 19.1391C116.783 19.1396 113.043 24.0875 113.043 24.0875Z",
    fill: "url(#paint17_linear_14011_169615)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.558 32.5636L126.091 34.0524C126.091 34.0524 126.182 29.8823 129.13 27.8597C126.48 28.1632 124.558 32.5636 124.558 32.5636Z",
    fill: "url(#paint18_linear_14011_169615)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.237 24.1241L109.77 25.6131C109.77 25.6131 109.859 21.4441 112.806 19.4231C110.159 19.7225 108.237 24.1241 108.237 24.1241Z",
    fill: "url(#paint19_linear_14011_169615)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M127.746 33.8131L128.27 35.0345C128.27 35.0345 129.322 32.66 131.497 32.2009C131.338 32.1554 131.173 32.1344 131.004 32.1342C129.494 32.1343 127.746 33.8131 127.746 33.8131Z",
    fill: "url(#paint20_linear_14011_169615)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.618 29.0633L119.996 32.2727C119.996 32.2727 122.756 26.0265 128.48 24.8244C128.059 24.7067 127.624 24.6518 127.181 24.6514C123.209 24.6491 118.618 29.0633 118.618 29.0633Z",
    fill: "url(#paint21_linear_14011_169615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.6687 157.519) rotate(90) scale(13.6714 57.3134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.5659 81.0418) scale(47.4669 31.6873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.68 57.6398) scale(13.5272 13.5261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.679 57.6398) scale(7.27659 7.27596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.4504 57.158) scale(13.5272 13.5261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14011_169615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.4502 57.1578) scale(7.27769 7.27705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_169615",
    x1: 77.4554,
    y1: 50.4517,
    x2: 77.4554,
    y2: 53.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_169615",
    x1: 109.685,
    y1: 50.4517,
    x2: 109.685,
    y2: 53.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_169615",
    x1: 93.5874,
    y1: 23.7568,
    x2: 93.5874,
    y2: 36.5282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_169615",
    x1: 94.915,
    y1: 23.6005,
    x2: 87.4497,
    y2: 29.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_169615",
    x1: 83.9874,
    y1: 19.9364,
    x2: 79.1763,
    y2: 26.2655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_169615",
    x1: 75.2539,
    y1: 22.2429,
    x2: 73.5624,
    y2: 27.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14011_169615",
    x1: 67.451,
    y1: 27.5308,
    x2: 64.7533,
    y2: 30.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14011_169615",
    x1: 63.0719,
    y1: 29.2584,
    x2: 62.2557,
    y2: 31.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14011_169615",
    x1: 60.5535,
    y1: 32.4906,
    x2: 59.4759,
    y2: 34.0979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14011_169615",
    x1: 93.0188,
    y1: 21.0631,
    x2: 100.971,
    y2: 25.5516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14011_169615",
    x1: 101.668,
    y1: 20.694,
    x2: 104.989,
    y2: 24.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14011_169615",
    x1: 112.478,
    y1: 23.197,
    x2: 114.646,
    y2: 26.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14011_169615",
    x1: 124.02,
    y1: 32.0412,
    x2: 126.09,
    y2: 34.0531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14011_169615",
    x1: 107.698,
    y1: 23.6014,
    x2: 109.769,
    y2: 25.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14011_169615",
    x1: 127.561,
    y1: 33.382,
    x2: 128.27,
    y2: 35.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14011_169615",
    x1: 118.129,
    y1: 27.931,
    x2: 119.994,
    y2: 32.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster1);
export default __webpack_public_path__ + "static/media/Monster1.e4c885a21e63d5cf707273c95f518c70.svg";
export { ForwardRef as ReactComponent };